// src/components/Termo.js (ou pages/Termo.js, dependendo da sua estrutura)

import React from "react";
// Não precisamos importar Head pois não é Next.js

// --- Constantes que você pode alterar facilmente ---
const COMPANY_NAME = "RagazziD";
const PRODUCT_NAME = "Radika";
const PRODUCT_DESCRIPTION =
  "Ferramenta para controle de acesso, gestão de venda e estoque "; // Ex: "de gestão de projetos", "de análise de dados", etc.
const CANCELLATION_SECTION_NAME = "Configurações de Conta"; // Ex: "Configurações de Conta", "Assinatura", etc.
const PRIVACY_POLICY_LINK = "politica-privacidade"; // Link para sua Política de Privacidade
const SUPPORT_WHATSAPP_NUMBER = "5519996547771"; // Seu número de WhatsApp com código do país (Ex: 5511999999999)
const SUPPORT_WHATSAPP_DISPLAY = "55 (19) 9 9654-7771"; // Como o número aparecerá no texto
const SUPPORT_START_TIME = "09:00";
const SUPPORT_END_TIME = "18:00";
const SUPPORT_DAYS = "segunda a sexta-feira";
const TEST_ENVIRONMENT_ACCESS_TYPE = "público"; // Ex: "público", "mediante cadastro", etc.
const CONTACT_EMAIL = "contato@ragazzid.com.br";
const CITY_DATE_LOCATION = "Campinas, 25 de Junho de 2025."; // A data atualizada e cidade

const Termo = () => {
  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-lg-10 col-md-12">
          <div className="card shadow-lg p-4 p-md-5">
            <h1 className="card-title text-center mb-4 display-4 font-weight-bold">
              Termo de Compromisso de Uso do {PRODUCT_NAME}
            </h1>
            <p className="lead text-center text-muted mb-5">
              Este Termo de Compromisso de Uso (doravante "Termo") estabelece as
              condições para a utilização da plataforma Radika, desenvolvida e
              disponibilizada por RagazziD, inscrita sob o CNPJ
              28.480.888/0001-26 (doravante "Radika" ou "Nós" ou "RagazziD"). Ao
              acessar e utilizar a plataforma Radika, o usuário (doravante
              "Você" ou "Usuário") concorda com as cláusulas e condições
              descritas neste Termo. Este Termo de Compromisso de Uso (doravante
              "Termo") estabelece as condições para a utilização da plataforma{" "}
              {PRODUCT_NAME}.
            </p>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">1. Objeto</h2>
              <p className="text-secondary">
                Este Termo regula o uso da plataforma web {PRODUCT_NAME},{" "}
                {PRODUCT_DESCRIPTION}. O acesso e utilização da plataforma são
                feitos exclusivamente online, sem a necessidade de instalação de
                software.
              </p>
            </section>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">
                2. Contratação e Pagamento
              </h2>
              <p className="text-secondary">
                2.1. O acesso ao {PRODUCT_NAME} se dá mediante contratação
                online através da plataforma web.
              </p>
              <p className="text-secondary">
                2.2. A cobrança pelo uso da plataforma será realizada por meio
                da plataforma de pagamentos Stripe.
              </p>
            </section>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">
                3. Cancelamento e Rescisão
              </h2>
              <p className="text-secondary">
                3.1.{" "}
                <strong className="font-weight-bold">
                  Cancelamento pelo {PRODUCT_NAME}:
                </strong>{" "}
                Nós nos reservamos o direito de cancelar o seu acesso ao{" "}
                {PRODUCT_NAME} a qualquer momento, seja por descontinuidade do
                produto, identificação de mau uso da plataforma por parte do
                Usuário, violação das condições deste Termo ou qualquer outra
                razão que considerarmos pertinente, mediante notificação prévia,
                quando aplicável.
              </p>
              <p className="text-secondary">
                3.2.{" "}
                <strong className="font-weight-bold">
                  Cancelamento pelo Usuário:
                </strong>{" "}
                Você pode cancelar o uso do {PRODUCT_NAME} a qualquer momento,
                sem necessidade de aviso prévio. O cancelamento pode ser feito
                diretamente na plataforma {PRODUCT_NAME}, na seção
                <strong className="font-weight-bold">
                  {" "}
                  {CANCELLATION_SECTION_NAME}
                </strong>
                .
              </p>
            </section>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">
                4. Proteção de Dados (LGPD)
              </h2>
              <p className="text-secondary">
                4.1. Todos os dados inseridos e processados na plataforma{" "}
                {PRODUCT_NAME} serão tratados em conformidade com a Lei Geral de
                Proteção de Dados (LGPD – Lei nº 13.709/2018).
              </p>
              <p className="text-secondary">
                4.2. Nós nos comprometemos a adotar as medidas técnicas e
                organizacionais adequadas para proteger os dados pessoais dos
                Usuários contra acesso não autorizado, divulgação, alteração ou
                destruição.
              </p>
              <p className="text-secondary">
                4.3. Para mais informações sobre como coletamos, usamos e
                protegemos seus dados, consulte nossa{" "}
                <strong className="font-weight-bold">
                  Política de Privacidade
                </strong>
                , disponível em{" "}
                <a href={PRIVACY_POLICY_LINK} className="text-info">
                  {" "}
                  {PRIVACY_POLICY_LINK}
                </a>
                .
              </p>
            </section>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">5. Suporte e Comunicação</h2>
              <p className="text-secondary">
                5.1. Para reportar bugs, problemas ou buscar suporte relacionado
                ao {PRODUCT_NAME}, o Usuário terá acesso aos seguintes canais de
                comunicação:
              </p>
              <ul className="list-unstyled text-secondary ml-4 mb-2">
                <li>
                  <strong className="font-weight-bold">
                    Email de Suporte:
                  </strong>{" "}
                  <a href={`mailto:${CONTACT_EMAIL}`} className="text-info">
                    {CONTACT_EMAIL}
                  </a>
                </li>
                <li>
                  <strong className="font-weight-bold">WhatsApp:</strong>{" "}
                  <a
                    href={`https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`}
                    className="text-info"
                  >
                    {SUPPORT_WHATSAPP_DISPLAY}
                  </a>
                </li>
              </ul>
              <p className="text-secondary">
                5.2. O horário de atendimento para suporte técnico é de{" "}
                <strong className="font-weight-bold">
                  {SUPPORT_START_TIME}
                </strong>{" "}
                às{" "}
                <strong className="font-weight-bold">{SUPPORT_END_TIME}</strong>{" "}
                de <strong className="font-weight-bold">{SUPPORT_DAYS}</strong>.
              </p>
              <p className="text-secondary">
                5.3. Ligações telefônicas para fins de suporte fora do horário
                comercial, para problemas que não afetem o funcionamento crítico
                do sistema (indisponibilidade total, perda de dados), podem
                estar sujeitas a multa, conforme termos e condições específicas
                a serem comunicados. Recomendamos a utilização dos canais
                oficiais de comunicação para agilizar o atendimento.
              </p>
            </section>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">6. Teste e Demonstração</h2>
              <p className="text-secondary">
                O {PRODUCT_NAME} disponibilizará um link para que o sistema
                possa ser testado continuamente, permitindo que potenciais
                usuários e parceiros avaliem suas funcionalidades. O acesso a
                este ambiente de teste é{" "}
                <strong className="font-weight-bold">
                  {TEST_ENVIRONMENT_ACCESS_TYPE}
                </strong>
                .
              </p>
            </section>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">
                7. Relatórios e Exportação de Dados
              </h2>
              <p className="text-secondary">
                7.1. A plataforma {PRODUCT_NAME} oferecerá páginas de relatórios
                para visualização e análise de dados.
              </p>
              <p className="text-secondary">
                7.2. O Usuário terá a possibilidade de baixar seus dados
                armazenados na plataforma, sempre em conformidade com os
                princípios e direitos estabelecidos pela Lei Geral de Proteção
                de Dados (LGPD).
              </p>
            </section>

            <section className="mb-4">
              <h2 className="h4 text-primary mb-3">
                8. Direito ao Esquecimento
              </h2>
              <p className="text-secondary">
                Em conformidade com a LGPD, o Usuário tem o direito de solicitar
                a exclusão de seus dados pessoais da plataforma {PRODUCT_NAME}.
                Para exercer esse direito, o Usuário deverá enviar um e-mail
                para{" "}
                <a href={`mailto:${CONTACT_EMAIL}`} className="text-info">
                  {CONTACT_EMAIL}
                </a>{" "}
                com a solicitação de remoção de dados. O {PRODUCT_NAME} tomará
                as medidas cabíveis para atender à solicitação dentro dos prazos
                legais, ressalvadas as obrigações legais de retenção de
                informações.
              </p>
            </section>

            <p className="text-muted text-right mt-5 mb-0">
              {CITY_DATE_LOCATION}
            </p>
            <p className="text-muted text-right font-weight-bold">
              {COMPANY_NAME}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Termo;
